import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "../../api-utility/axiosInstance";

// CREATE PERSON
export const createPerson = createAsyncThunk(
  "persons/add",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(`/tenant/customers/${id}/persons`, payload);

      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: "Failed to create person" });
    }
  }
);

// UPDATE PERSON
export const updatePerson = createAsyncThunk(
  "persons/update",
  async ({ customerId, personId, payload }, { rejectWithValue }) => {
    try {
      const res = await Axios.put(`/tenant/customers/${customerId}/persons/${personId}`, payload);

      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: "Failed to update person" });
    }
  }
);

// DELETE PERSON
export const deletePerson = createAsyncThunk(
  "persons/delete",
  async ({ customerId, personId }, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(`/tenant/customers/${customerId}/persons/${personId}`);

      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to delete person");
    }
  }
);

const personSlice = createSlice({
  name: "persons",
  initialState: {
    isLoading: false,
    error: null,
    isBulkDeleting: false,
  },
  reducers: {},
});

export default personSlice.reducer;
